import React from 'react';
import { CheckCircle2, ShoppingCart, CreditCard, ShieldCheck, Monitor } from 'lucide-react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const PdvPage = () => {
  const features = [
    'Vendas rápidas no balcão',
    'Controle completo de caixa',
    'Múltiplas formas de pagamento',
    'Emissão de NFC-e integrada',
    'Prestação de contas automatizada',
    'Integração total com ERP'
  ];

  return (
    <div>
      <PageHero
        eyebrow="Zartoo PDV"
        title="Vendas rápidas. Controle total."
        subtitle="PDV integrado ao ERP para atender com agilidade e segurança fiscal."
        primaryCta={{ label: 'Solicitar orçamento', href: '/planos' }}
        secondaryCta={{ label: 'Falar com especialista', href: '/especialista' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Funcionalidades"
            title="Tudo o que seu balcão precisa"
            description="Interface intuitiva com emissão fiscal e controle financeiro integrado."
          />
          <div className="grid md:grid-cols-3 gap-6">
            <Card>
              <ShoppingCart className="w-6 h-6 text-[#FF6B35]" />
              <h3 className="text-xl font-semibold mt-3">Operação ágil</h3>
              <p className="text-slate-200/80 mt-2">Fluxo rápido para atender mais clientes.</p>
            </Card>
            <Card>
              <CreditCard className="w-6 h-6 text-[#FF6B35]" />
              <h3 className="text-xl font-semibold mt-3">Pagamentos flexíveis</h3>
              <p className="text-slate-200/80 mt-2">Cartão, PIX, dinheiro e combinações.</p>
            </Card>
            <Card>
              <ShieldCheck className="w-6 h-6 text-[#FF6B35]" />
              <h3 className="text-xl font-semibold mt-3">Conformidade fiscal</h3>
              <p className="text-slate-200/80 mt-2">NFC-e e relatórios sempre em dia.</p>
            </Card>
          </div>
        </div>
      </section>

      <section className="bg-slate-900/80">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Benefícios"
            title="Integração total com o ERP"
            description="Estoque e financeiro atualizados em tempo real."
          />
          <div className="grid md:grid-cols-2 gap-6">
            <Card>
              <Monitor className="w-6 h-6 text-[#4FC3F7]" />
              <h3 className="text-xl font-semibold mt-3">Dashboard da loja</h3>
              <p className="text-slate-200/80 mt-2">Acompanhe vendas, caixa e performance por loja.</p>
            </Card>
            <Card>
              <ul className="space-y-2 text-sm text-slate-200/80">
                {features.map((item) => (
                  <li key={item} className="flex items-center gap-2">
                    <CheckCircle2 className="w-4 h-4 text-[#FF6B35]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Card>
          </div>
        </div>
      </section>

      <section className="bg-white text-slate-900">
        <div className="container mx-auto px-8 lg:px-12 py-16 text-center">
          <SectionTitle
            eyebrow="CTA"
            title="Pronto para modernizar seu PDV?"
            description="Receba uma proposta personalizada para o seu negócio."
            mode="light"
          />
          <a
            href="/contato"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-black text-lg bg-[#FF6B35] text-white hover:shadow-orange-500/40 transition-all"
          >
            Falar com consultor
          </a>
        </div>
      </section>
    </div>
  );
};

export default PdvPage;
